import { createSelector } from "reselect";
import { initialState } from "./index";

export const selectAuth = (state) => state.AuthReducer || initialState;

export const selectUser = createSelector(
  selectAuth,
  (data) => data.user
);
